import { getItemFromPersistentStore, clearPersistentStore, setItemInPersistentStore } from '../../../common/utils/Persist';
import types from '../types';

const signoutUserCleanUp = (payload, data) => {
  const { history, type, onSuccess } = payload;
  const language = getItemFromPersistentStore('language');
  const messages = getItemFromPersistentStore('messages');
  const coachMarkApiFetched = getItemFromPersistentStore('coachMarkApiFetched');
  clearPersistentStore();
  if (language) setItemInPersistentStore('language', language);
  if (messages) setItemInPersistentStore('messages', messages);
  if (coachMarkApiFetched) setItemInPersistentStore('coachMarkApiFetched', coachMarkApiFetched);
  if (!type || type !== 'sso') {
    history && history.push('/');
  } else if (onSuccess) {
    onSuccess(data);
  }
  return {
    type: types.app.SIGN_OUT_USER_SUCCESS,
    payload: null
  };
}
export default signoutUserCleanUp